import { cn } from '@/lib/utils'

type ButtonVariant = 'primary' | 'outline' | 'ghost' | 'champagne' | 'outline-light'
type ButtonSize = 'sm' | 'md' | 'lg'

const BUTTON_BASE = 'inline-flex shrink-0 items-center justify-center gap-2 rounded-full font-semibold whitespace-nowrap transition-all duration-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background disabled:pointer-events-none disabled:opacity-60'

const BUTTON_VARIANTS: Record<ButtonVariant, string> = {
    'primary': 'bg-primary text-primary-foreground shadow-sm hover:bg-primary/90 hover:shadow-md',
    'outline': 'border border-foreground/15 text-foreground hover:border-foreground/40 hover:bg-foreground/[0.03]',
    'ghost': 'text-foreground hover:bg-foreground/5',
    'champagne': 'bg-champagne text-foreground shadow-sm hover:bg-champagne/85',
    'outline-light': 'border border-background/25 text-background hover:border-background/60 hover:bg-background/5'
}

const BUTTON_SIZES: Record<ButtonSize, string> = {
    sm: 'h-9 px-4 text-sm',
    md: 'h-11 px-6 text-sm',
    lg: 'h-13 px-7 text-base'
}

// Shared class names for links and buttons that look like buttons.
export const buttonClass = (variant: ButtonVariant = 'primary', size: ButtonSize = 'md', className?: string): string => {
    return cn(BUTTON_BASE, BUTTON_VARIANTS[variant], BUTTON_SIZES[size], className)
}
